export const removeSearchParam = (url, searchParam) => {
  const [pageUrl, searchParams] = url.split('?');

  const params = new URLSearchParams(searchParams);
  params.delete(searchParam);

  const cleanedUrl = `${pageUrl}?${params}`;
  return cleanedUrl;
};
